import { ReactNode } from "react";
import { Space, Typography } from "antd";

import { ERPBreadcrumb, type ERPBreadcrumbItem } from "./ERPBreadcrumb";

const { Paragraph, Title } = Typography;

export interface PageHeadingProps {
  title: string;
  description?: ReactNode;
  eyebrow?: string;
  action?: ReactNode;
  breadcrumbItems?: ERPBreadcrumbItem[];
}

export const PageHeading = ({
  action,
  breadcrumbItems,
  description,
  title,
}: PageHeadingProps) => (
  <div className="page-heading">
    <div className="page-heading__copy">
      {breadcrumbItems?.length ? (
        <div className="page-heading__breadcrumb">
          <ERPBreadcrumb items={breadcrumbItems} />
        </div>
      ) : null}
      {/* {eyebrow ? (
        <Text className="page-heading__eyebrow">{eyebrow}</Text>
      ) : null} */}
      <Title level={2} style={{ marginBottom: 0 }}>
        {title}
      </Title>
      {description ? (
        <Paragraph type="secondary">{description}</Paragraph>
      ) : null}
    </div>
    {action ? (
      <Space className="page-heading__action" wrap>
        {action}
      </Space>
    ) : null}
  </div>
);
